import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NbValueAccessor } from '@app/common/basic/models/nb-value-accessor';

type NB_INPUT_TYPE = 'text' | 'password' | 'email' | 'number';

@Component({
  selector: 'nb-input',
  templateUrl: './nb-input.component.html',
  styleUrls: ['./nb-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbInputComponent extends NbValueAccessor<string | number> implements OnInit {
  @Input()
  prependIcon: string;

  @Input()
  appendIcon: string;

  @Input()
  type: NB_INPUT_TYPE = 'text';

  @Input()
  placeholder = '';

  @Output()
  clear = new EventEmitter<void>();

  @Output()
  change = new EventEmitter<string | number>();

  setModel = (val: string | number) => {
    this.writeValue(val);
    this.change.emit(val);
  };

  clearModel = () => {
    this.writeValue('');
    this.clear.emit();
  };

  ngOnInit() {}
}
